module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-ranking-1125cdbeb9aeec002c5a00c80229b897.png";